import { reducer } from "ts-action";
import { on } from "ts-action-immer";
import * as AC from "../actionCreators";
import { HegUserDTO } from "../../../requests/hegMapping/types";

export type MappingState = {
  isMapped: boolean;
  mappedPwdOk: boolean;
  isBasicLoginType: boolean;
  isDomainLoginType: boolean;
  isGoogleLoginType: boolean;
};

export type State = {
  datasourceId: number;
  userMapping: MappingState;
  defaultMapping: MappingState;
  hegUser: HegUserDTO | null;
  defaultHegUser: HegUserDTO | null;
  // isChecking pro celý slice je z praktických vedle dictu - důvod je popsán v redux wiki
  isFetchingUsername: boolean;
  isSubmittingUsername: boolean;
  isSubmittingPassword: boolean;
};

// Kdyz necastnu, tak si TS mysli, ze je state vzdy undefined, i kdyz to mam manualne otypovany...
const initialState: State | undefined = undefined as State | undefined;

// stav je vždy undefined do prvniho successful mapping checku - imo je to tak nejbezpečnější
const forDatasourceIdReducer = reducer(
  initialState,
  on(AC.checkMappingResponse, (state, action) => {
    const { datasourceId, userMapping, defaultMapping } = action.payload;

    const newState: State = {
      // defaults pro první průchod
      hegUser: null,
      defaultHegUser: null,
      isSubmittingUsername: false,
      isSubmittingPassword: false,
      isFetchingUsername: false,
      ...state,
      datasourceId,
      userMapping,
      defaultMapping,
    };

    return newState;
  }),

  on(AC.getHegUserResponse, (state, action) => {
    if (!state) return;
    state.hegUser = action.payload.user;
    state.isFetchingUsername = false;
  }),

  on(AC.updateHegUserResponse, (state, action) => {
    if (!state) return;

    if (action.payload.defaultMapping) {
      state.defaultHegUser = action.payload.user;
      state.defaultMapping.isMapped = true;
    } else {
      state.hegUser = action.payload.user;
      state.userMapping.isMapped = true;
    }

    state.isSubmittingUsername = false;
  }),

  on(AC.resetHegUserResponse, (state, action) => {
    if (!state) return;
    state.hegUser = null;
    state.userMapping.isMapped = false;
    state.isSubmittingUsername = false;
  }),

  on(AC.resetDefaultHegUserResponse, (state, action) => {
    if (!state) return;
    state.defaultHegUser = null;
    state.defaultMapping.isMapped = false;
    state.isSubmittingUsername = false;
  }),

  // isSubmitting bullcrap
  on(AC.submitHegPasswordRequest, (state, action) => {
    if (!state) return;
    state.isSubmittingPassword = true;
  }),
  on(
    AC.submitHegPasswordResponse,
    AC.submitHegPasswordError,
    (state, action) => {
      if (!state) return;
      state.isSubmittingPassword = false;
    }
  ),
  on(
    AC.updateHegUserRequest,
    AC.resetHegUserRequest,
    AC.resetDefaultHegUserRequest,
    (state, action) => {
      if (!state) return;
      state.isSubmittingUsername = true;
    }
  ),
  on(
    AC.updateHegUserError,
    AC.resetHegUserError,
    AC.resetDefaultHegUserError,
    (state, action) => {
      if (!state) return;
      state.isSubmittingUsername = false;
    }
  ),
  on(AC.getHegUserRequest, (state, action) => {
    if (!state) return;
    state.isFetchingUsername = true;
  }),
  on(AC.getHegUserError, (state, action) => {
    if (!state) return;
    state.isFetchingUsername = false;
  })
);

export default forDatasourceIdReducer;
export type ForDatasourceIdState = State;
